import 'core-js';
import 'styles/resets.css';
import 'styles/vendors.css';
import 'styles/global.css';

import React from 'react';
import ReactDOM from 'react-dom';

import Core from 'modules/core';
import Application from 'modules/application';

import loadPolyfills from './polyfills';

// Suppress ResizeObserver errors - these are benign warnings from browser
const originalError = console.error;
console.error = (...args) => {
    if (
        typeof args[0] === 'string' &&
        (args[0].includes('ResizeObserver loop') ||
            args[0].includes('ResizeObserver loop completed with undelivered notifications'))
    ) {
        return; // Suppress ResizeObserver errors
    }
    // Suppress Airtime widget duplicate registration errors
    if (
        typeof args[0] === 'string' &&
        args[0].includes('airtime-widget') &&
        (args[0].includes('already been used') || args[0].includes('has already been used'))
    ) {
        return; // Suppress Airtime widget errors
    }
    originalError.apply(console, args);
};

// Also suppress unhandled promise rejections for ResizeObserver
window.addEventListener('error', event => {
    if (
        event.message &&
        (event.message.includes('ResizeObserver loop') ||
            event.message.includes('ResizeObserver loop completed with undelivered notifications'))
    ) {
        event.preventDefault();
        return false;
    }
    // Suppress Airtime widget duplicate registration errors
    if (
        event.message &&
        (event.message.includes('airtime-widget') &&
            (event.message.includes('already been used') || event.message.includes('has already been used')))
    ) {
        event.preventDefault();
        return false;
    }
});

const renderApp = () => {
    ReactDOM.render(
        <Core>
            <Application />
        </Core>,
        document.getElementById('root'),
    );
};

loadPolyfills()
    .then(renderApp)
    .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Failed to load polyfills', error);
        renderApp();
    });
